module.exports = __webpack_public_path__ + "img/out-money.0710bdc0.png";